export default class Utils {
  static DEV_MODE = process.env.NODE_ENV === 'development';
  static STAGING_MODE = window.document.domain.indexOf('stage') !== -1;

  static GAME_NAMES = {
    1: 'Virtual Football',
    2: 'Penalty Kicks',
    3: 'Virtual Horse Racing',
    4: 'Virtual Greyhounds',
    6: 'Virtual Bicycle',
    7: 'Virtual Football League',
    8: 'Spin To Win',
    9: 'Drag Racing',
    12: 'Marble Racing',
    13: 'World Wrestling',
    14: 'Virtual Tennis',
    15: 'Spin To Win Deluxe',
    16: 'Virtual Horse Bet Shop',
    17: 'Virtual Greyhounds Bet Shop',
    18: 'Virtual Bicycle Bet Shop',
    19: 'Virtual Marble Bet Shop',
  }

  static getUniqNumber() {
    return (Date.now() * Math.floor(Math.random() * 100)) * Math.random();
  }

  static blockInvalidNumbers = e => {
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  }

  static blockInvalidPastedNumbers = e => {
    const cbValue = e.clipboardData.getData('Text');

    if (cbValue.includes('E') || cbValue.includes('e') || cbValue.includes('+') || cbValue.includes('-')) {
      e.preventDefault();
    }
  }

  /**
   * @returns object first key
   */
  static firstKey(object) {
    return object ? Object.keys(object)[0] : '';
  }
}